import { useEffect }          from 'react';
import { store }              from 'index';
import { groupUrl }           from 'utils/constants'
import { GET_TUTORIALS_SAGA } from 'actions';

const useGetTutorials = () => {

    const state     = store.getState();
    const tutorials = state.content.tutorials;


    useEffect(() => {

        if ( !groupUrl && tutorials.length === 0 ) {
            store.dispatch(GET_TUTORIALS_SAGA());
        }
   
      },[ tutorials ])


}
export default useGetTutorials;





   